var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPedagogical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.97 246.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #deeaeb;\n      }\n\n      .cls-2 {\n        fill: #fafafa;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #cedadd;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: #e1eaeb;\n      }\n\n      .cls-6 {\n        fill: #f4c668;\n      }\n\n      .cls-7 {\n        fill: #ace0e9;\n      }\n\n      .cls-8, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        fill: #f7d882;\n      }\n\n      .cls-10 {\n        fill: #3c717f;\n      }\n\n      .cls-11 {\n        fill: #e9f0f1;\n      }\n\n      .cls-12 {\n        fill: #77adc1;\n      }\n\n      .cls-4 {\n        stroke: #acc9d0;\n      }\n\n      .cls-13 {\n        fill: #41707c;\n      }\n\n      .cls-14 {\n        fill: #eef0f0;\n      }\n\n      .cls-15 {\n        fill: #f2b864;\n      }\n\n      .cls-16 {\n        fill: #eaf2f3;\n        opacity: .68;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.39,220.69S-10.84,186.7,1.47,132.14s53.33-38.56,71.79-45.54,32.41-21.74,41.85-40.21S188.95-1.19,214.8.04s48.82,31.18,69.74,47.18,44.31,30.51,69.33,14.44,66.05,2.79,45.54,31.51-65.23,13.95-65.23,26.67,29.54,31.47,31.18,64.35-67.28,43.56-67.28,43.56l-239.69-7.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 272.01,
    y: 39.57,
    width: 40.21,
    height: 48,
    rx: 5.53,
    ry: 5.53,
    transform: "translate(24.2 -69.07) rotate(14.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.85,208.9c-1.64.3-32.41,4.81-42.46,11.79s3.9,25.03,108.92,25.44,157.54-13.54,160.41-16.41-15.59-16.19-65.23-20.81-161.64,0-161.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.2,207.87s-18.17-4.46-22.17-5.08-2.46-6.46,0-7.38,2.15-4.31,2.15-4.31c0,0-20.31-5.54-24-6.92s-5.54-10.62,3.69-11.23,15.08,0,15.08,0c0,0-20.62-12.92-26.77-14.46s-15.69-12-6.46-12.62,24.8.31,27.32,3.69,4.06,4,4.06,4c0,0-14.46-16-10.46-24.92s13.23,3.08,15.38,8.31,3.38,7.08,3.38,7.08c0,0-2.77-20.21,2.97-27.38s9.23-10.67,12.51,1.23-2.05,37.54-2.05,37.54c0,0,7.18-12.1,11.08-13.13s11.49.21,6.77,9.85-10.26,19.69-10.26,19.69c0,0,8.82-5.95,10.67-2.26s-5.13,11.28-5.33,16.82,4.72-5.64,8.41-2.21-13.54,24.47-13.54,24.47l-2.44-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.87,213.57s-5.23-22.77-13.54-39.38-12.31-20.62-12.31-20.62c0,0,12.62,21.23,17.54,37.54s6.15,23.69,6.15,23.69l2.15-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.13,221.62s-16.31-1.67-8.92-4.75,61.23-14.77,128.62-12.31-91.08,18.77-92.62,18.77-27.08-1.71-27.08-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.13,221.62s103.08-2.46,144.31-.92,46.15,5.23,46.15,5.23c0,0-.58,4.31-74.75,5.54s-103.71-6.15-115.71-9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M83.83,129.52s2.77-12.62,11.38-13.54,173.23,0,173.23,0c0,0,10.77-1.54,8.62,13.54s-6.15,41.23-6.15,41.23l-179.38,1.23-7.69-42.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.04,145.13v-55.57l1.15-1.42v-26.4c0-2.02-1.63-3.65-3.65-3.65h-25.22l-5.63,2.32h-56.87c-2,0-3.62,1.62-3.62,3.62v64.8l46.92,22.04h49.08l-2.16-5.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "132.2 123.78 152.69 123.78 171.42 139.47 225.36 139.47 225.36 147.78 139.36 147.78 132.2 147.78 132.2 123.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.83,128.7l13.23,88.92s-1.23,9.74,16.62,10.1,146.15,0,146.15,0c0,0,10.46,1.59,12.92-10.72s9.23-54.46,9.23-54.46c0,0,3.08-17.23-20.31-17.23s-85.54-.62-85.54-.62c0,0-8,3.08-13.85-7.69s-8.62-8.62-20.92-8.31-57.54,0-57.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.14,219.15s13.14,4.32,66.99,4.32,60.62.62,80.31,0,27.76-4.32,27.76-4.32c0,0-.68,8.55-12.37,8.58s-146.15,0-146.15,0c0,0-15.47-.51-16.53-8.58Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "143.83 80.7 193.8 80.7 210.9 78.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.83,
    y1: 95.47,
    x2: 196.75,
    y2: 95.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.83,
    y1: 109.63,
    x2: 204.13,
    y2: 109.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M76.13,48.5l-34.26,26.31s4.46,7.69,3.38,11.23,30.87-37.54,30.87-37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M45.26,86.04s5.13-5.54,10.41-4,7.74,4,7.74,4l12.72-37.54-30.87,37.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "41.88 74.81 25.11 71.88 76.13 48.5 41.88 74.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 117.98,
    cy: 29.47,
    r: 5.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 117.98,
    cy: 29.47,
    r: 12.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 117.98,
    cy: 29.47,
    r: 5.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 265.45,
    y: 43.27,
    width: 40.21,
    height: 48,
    rx: 5.53,
    ry: 5.53,
    transform: "translate(6.15 -22.17) rotate(4.49)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 272.75,
    y1: 53.06,
    x2: 299.09,
    y2: 54.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 272.75,
    y1: 62.03,
    x2: 299.09,
    y2: 63.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 272.28,
    y1: 71,
    x2: 298.62,
    y2: 72.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 272.28,
    y1: 78.72,
    x2: 298.62,
    y2: 80.26
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 218.83,
    cy: 63.01,
    r: 26.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "235.7 89.41 239.47 94.91 245.98 88.37 241.84 84.21 235.7 89.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217.68,34.81c-16.72,0-30.27,13.55-30.27,30.27s13.55,30.27,30.27,30.27,30.27-13.55,30.27-30.27-13.55-30.27-30.27-30.27ZM217.68,88.95c-13.19,0-23.88-10.69-23.88-23.88s10.69-23.88,23.88-23.88,23.88,10.69,23.88,23.88-10.69,23.88-23.88,23.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M239.21,94.09s-1.3,5.14,3.58,10.02,15.81,18.83,15.81,18.83c0,0,2.29,5.43,5.52,3.39s8.63-8.83,8.63-8.83c0,0-.69-.83-3.38-3.41s-19.95-19.95-19.95-19.95l-5.39-5.08-4.8,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M219.93,32.74c-16.72,0-30.27,13.55-30.27,30.27s13.55,30.27,30.27,30.27,30.27-13.55,30.27-30.27-13.55-30.27-30.27-30.27ZM219.93,86.89c-13.19,0-23.88-10.69-23.88-23.88s10.69-23.88,23.88-23.88,23.88,10.69,23.88,23.88-10.69,23.88-23.88,23.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "236.42 88.4 239.78 93.28 245.58 87.48 241.89 83.79 236.42 88.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M239.78,93.28s-.84,3.87,4.04,8.74,15.81,18.83,15.81,18.83c0,0,2.29,5.43,5.52,3.39s7.6-6.75,7.6-6.75c0,0,.34-2.91-2.35-5.49s-19.95-19.95-19.95-19.95l-4.85-4.57-5.8,5.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.55,47.98s-5.66,1.85-7.06,8.77-1.71,11.85.29,12.31,5.38-6.15,5.23-9.69,3.08-5.69,7.08-7.23,1.69-7.23-5.54-4.15Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPedagogical);
export default __webpack_public_path__ + "static/media/empty_pedagogical.5e46c928d9b0c2e2fe2da0b524a1cf71.svg";
export { ForwardRef as ReactComponent };